<template>
  <div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step
          color="amber"
          :complete="e1 > 1"
          step="1"
          @click="el = 1"
          >Key Messaages</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step
          color="amber"
          :complete="e1 > 2"
          step="2"
          @click="el = 2"
          >Prioritise</v-stepper-step
        >
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-row>
            <v-col cols="4" class="mb-4">
              <h2 v-text="$t('exercise_message.step1.title')"></h2>
            </v-col>
            <v-col cols="8" class="mb-4">
              <p
                v-for="(item, index) in $t(
                  'exercise_message.step1.description'
                )"
                :key="index"
                v-text="item"
              />
              <v-btn light @click="addItem" color="amber" class="mt-5 mb-5"
                >Add message</v-btn
              >
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <div v-if="proposition">
                <v-card>
                  <v-card-title class=""
                    >Ingredients from the brand statement exercise</v-card-title
                  >
                  <v-card-text>
                    <p class="blue--text title mb-0">Audience</p>
                    <ul>
                      <li
                        class="ma-1"
                        v-for="(tag, index) in proposition.audience"
                        :key="index"
                      >
                        <span class="pr-2">{{ tag }}</span>
                      </li>
                    </ul>

                    <p class="green--text title mb-0">Features</p>
                    <ul>
                      <li
                        class="ma-1"
                        v-for="(tag, index) in proposition.features"
                        :key="index"
                      >
                        <span class="pr-2">{{ tag }}</span>
                      </li>
                    </ul>

                    <p class="deep-orange--text title mb-0">Benefits</p>
                    <ul>
                      <li
                        class="ma-1"
                        v-for="(tag, index) in proposition.benefits"
                        :key="index"
                      >
                        <span class="pr-2">{{ tag }}</span>
                      </li>
                    </ul>

                    <p class="pink--text title mb-0">Reason to believe</p>
                    <ul>
                      <li
                        class="ma-1"
                        v-for="(tag, index) in proposition.reasons"
                        :key="index"
                      >
                        <span class="pr-2">{{ tag }}</span>
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
            <v-col cols="6">
              <div v-for="item in items" :key="item.id">
                <v-card light class="mb-5">
                  <v-card-text>
                    <p
                      class="body-1 font-weight-regular"
                      v-html="item.message"
                    ></p>
                    <v-chip
                      color="grey lighten-2 mr-2"
                      @click="editItem(item.id)"
                      >Edit</v-chip
                    >
                    <v-chip
                      color="grey lighten-2"
                      @click="deleteAlert(item.id)"
                    >
                      Delete
                    </v-chip>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>

          <bottom-navigation
            :save="false"
            :next="true"
            :prev="false"
            :gridView="false"
            :gridToggle="false"
            @save="saveExercise"
            @prev="prevStep"
            @next="nextStep"
          >
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-row>
            <v-col cols="4" class="mb-4">
              <h2 v-text="$t('exercise_message.step2.title')"></h2>
            </v-col>

            <v-col cols="8" class="mb-4">
              <p
                v-for="(item, index) in $t(
                  'exercise_message.step2.description'
                )"
                :key="index"
                v-text="item"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" offset="4">
              <Ordering v-model="list" name="messageOrder">
                <message-card
                  :all="items"
                  :card="item"
                  v-for="item in list"
                  :key="item.id"
                  :data-id="item.id"
                  class="mb-3"
                ></message-card>
              </Ordering>
            </v-col>
          </v-row>

          <bottom-navigation
            :save="true"
            :next="false"
            :prev="true"
            :gridView="false"
            :gridToggle="false"
            @save="saveExercise"
            @prev="prevStep"
            @next="nextStep"
          >
          </bottom-navigation>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" max-width="600">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_message.saved.title')"
        ></v-card-title>

        <v-card-text
          v-text="$t('exercise_message.saved.description')"
        ></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>

          <v-btn
            color="amber accent-1"
            text
            :to="`/users/project/${this.$route.params.id}`"
          >
            Back to Project
          </v-btn>
          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add message</v-card-title>

        <v-card-text>
          <message-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <message-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'delete'">
        <v-card-title class="headline"
          >Are you sure you want to delete</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog()">
            Cancel
          </v-btn>

          <v-btn color="amber" @click="deleteItem()">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation, Ordering } from "@/components/core";
import { MessageAdd, MessageEdit, MessageCard } from "./message";
// import lodash from "lodash";
// import draggable from "vuedraggable";
// relies on user proposition exercise

const fb = require("@/firebaseConfig.js");
export default {
  name: "UserMessage",
  data() {
    return {
      collection: fb.messageExCollection,
      returnRoute: "UserMessage",
      e1: 1,
      dialog: false,
      dialogMode: "",
      exercise: null,
      debug: false,
      componentReady: false,
      intervalId: null,
      items: [],
      list: [],
      proposition: null,
      cardId: null,
    };
  },
  components: {
    BottomNavigation,
    MessageAdd,
    MessageEdit,
    MessageCard,
    Ordering,
  },
  watch: {
    e1(val) {
      if (val === 2) {
        this.createList();
      }
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  beforeRouteUpdate(to, from, next) {
    this.init();
    next();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      console.log("checking status");
      if (this.currentProjectModel && this.currentProjectModel.id) {
        this.componentReady = true;
        clearInterval(this.intervalId);
        this.loadMessages();
      }
    },
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    loadMessages() {
      console.log("load messages");
      let ref = fb.messageContentCollection.where(
        "pid",
        "==",
        `${this.currentProjectModel.id}`
      );
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        let mode = "";
        console.log(querySnapshot.docChanges()[0].type);

        if (
          querySnapshot.docChanges().length != querySnapshot.docs.length &&
          querySnapshot.docChanges()[0].type == "added"
        ) {
          mode = "added";
          let post = querySnapshot.docChanges()[0].doc.data();
          items.push(post);
        } else if (querySnapshot.docChanges()[0].type == "modified") {
          mode = "modified";
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
        } else if (querySnapshot.docChanges()[0].type == "removed") {
          mode = "removed";
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
        } else {
          mode = "all";
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
        }

        if (mode == "all" || mode == "added") {
          this.items = [...this.items, ...items];
        }
        if (mode == "modified" || mode == "removed") {
          this.items = [...items];
        }
      });
      this.getExercise();
      this.getProposition();
    },
    getProposition() {
      console.log("get proposition");
      let ref = fb.propositionExCollection
        .where("pid", "==", `${this.currentProjectModel.id}`)
        .where("uid", "==", this.currentUser.uid);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.proposition = items[0].doc;
      });
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.messageExCollection
        .where("pid", "==", `${this.currentProjectModel.id}`)
        .where("uid", "==", this.currentUser.uid);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.exercise = items[0];
        this.list = this.exercise.doc;
        let newNotes = [];
        this.items.forEach((x) => {
          if (!this.exercise.doc.some((y) => y.id == x.id)) {
            newNotes.push(x);
          }
        });
        if (this.exercise) {
          this.list = [...newNotes, ...this.exercise.doc];
        }
      });
    },
    saveExercise(notify) {
      // check if exercise exists
      let ref;
      let vm = this;
      if (this.exercise == null) {
        ref = fb.messageExCollection.doc();
      } else {
        ref = fb.messageExCollection.doc(this.exercise.id);
      }
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: this.currentUser.uid,
          pid: this.currentProjectModel.id,
          doc: this.list,
        })
        .then(() => {
          if (notify) {
            vm.dialogMode = "save";
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    addItem() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    createList() {
      // let list = [];
      // list = [...this.items];
      // let count = 0;
      // list.forEach((item) => {
      //   item.index = count;
      //   count++;
      // });
      // let list = lodash.orderBy(this.items, "value", "desc");
      console.log("create list");
      if (this.list.length === 0) {
        console.log("no list so making one");
        this.list = [...this.items];
      } else {
        // let newItems = [];
        // this.exercise.doc.forEach((x) => {
        //   if (this.items.some((y) => y.id == x.id)) {
        //     console.log('in list')

        //   } else {
        //     console.log('not in list')
        //     newItems.push(x);
        //   }
        // });
        // this.list = [...this.items];
        this.list = this.exercise.doc;
        // this.list = lodash.orderBy([...newItems, ...this.items], "index", "asc");

        // loop through the exercise list
        // id an item doesn't exist in the all remove it
      }
    },
    editItem(id) {
      this.dialogMode = "edit";
      this.cardId = id;
      this.dialog = true;
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
      this.cardId = null;
    },
    deleteAlert(id) {
      this.dialogMode = "delete";
      this.cardId = id;
      this.dialog = true;
    },
    deleteItem() {
      fb.messageContentCollection
        .doc(this.cardId)
        .delete()
        .then(() => {
          this.cardId = null;
          this.dialog = false;
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
  },
};
</script>
